<template>
  <div class="order-page" v-loading="loading">
    <div class="common-header">
      <es-breadcrumb class="breadcrumb">
        <es-button class="goback" icon="es-icon-arrow-left" shape="square" variant="outline" @click="$router.go(-1)" />
        <es-breadcrumb-item v-if="isInSaas">{{ $t('企业账户') }}</es-breadcrumb-item>
        <es-breadcrumb-item>{{ $t('确认订单') }}</es-breadcrumb-item>
        <template v-if="waitPay">
          <es-breadcrumb-item>{{ $t('支付') }}</es-breadcrumb-item>
        </template>
      </es-breadcrumb>
    </div>
    <div class="order-confirm">
      <div class="container">
        <PayCountDown
          class="pay-countdown"
          :isInvalid="isInvalid"
          :isPaySuccess="isPaySuccess"
          :seconds="waitSeconds"
          v-if="waitPay"
          @reOrder="handleReOrder"
          @reportGetCustomerSupport="reportGetCustomerSupport" />
        <div class="content">
          <!-- 商品信息模块 -->
          <ProductInfo
            class="product"
            :num="num"
            :count="count"
            :totalNum="totalNum"
            :hideContinuedType="hideContinuedType"
            :invoiceForm="form"
            :commodityInfo="orderId ? orderInfo : menuData"
            :tyingInfo="tyingInfo"
            :isTying="isTying"
            :isContinuedValidityTerm.sync="isContinuedValidityTerm"
            :useTime.sync="useTime"
            :menuTotalPrice="menuTotalPrice"
            @inputMoney="handleInput"
            @inputNum="handleChange"
            :invoice="invoice"
            @invoiceChange="needInvoice"
            :waitPay="waitPay"
            :showAutoBuy="showAutoBuy"
            :isDeliver="isDeliver"
            @getVal="getVal"
            :lastEndTime="lastEndTime"
            @invoiceSubmit="invoiceSubmit"
            @onTyingSaleSelectChange="tyingSaleSelectChange" />
          <!-- 支付模块  -->
          <PaymentInfo
            class="pay"
            @submitPayment="submitPayment"
            :billForm="billForm"
            :payAmountDisplay="payAmountDisplay"
            :menuTotalPrice="menuTotalPrice"
            :promotionDisplay="promotionDisplay"
            :getCoupons="getCoupons"
            :couponList="couponList"
            @couponChange="changeCoupon"
            :discounted="discounted"
            :coupenName="coupenName"
            :checkCoupons.sync="checkCoupons"
            :couponType="couponType"
            :menuStandardPriceDisplay="menuStandardPriceDisplay"
            @protocolChange="handleProtocolChange"
            :paying="paying"
            :balance="balance"
            :waitPay="waitPay"
            :couponsNumber="activeNo"
            :paymentMethod.sync="paymentMethod"
            :orderInfo="orderInfo"
            :isInvalid="isInvalid"
            :payAmount="payAmount" />
          <!-- 支付弹窗 -->
          <PaymentDialog
            ref="paymentRef"
            class="payment"
            :visible.sync="paymentDialogVisible"
            :paymentMethod="paymentMethod"
            :expressFee="billForm.express"
            :tyingSceneAmount="tyingSceneAmount"
            :waitPay="waitPay"
            :selectTyingSaleSchemaList="selectTyingSaleSchemaList"
            @close="handlePayClose" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'
import { base64Decode, getTimingData, numberCal, debounce } from '@/util'
import { mapState } from 'vuex'
import { orderSourceMap } from '@esign/esign-client-jssdk'
import tsignDataTrack from '@tsign/tsigndata-sdk-js'
import { PAYMENT_METHOD } from '@/consts/payment'
import ProductInfo from './productInfo.vue'
import PaymentInfo from './paymentInfo.vue'
import PaymentDialog from './paymentDialog/index.vue'
import PayCountDown from './payCountDown.vue'
const debounceTime = 1000

export default {
  name: 'OrderConfirm',
  components: {
    ProductInfo,
    PaymentInfo,
    PaymentDialog,
    PayCountDown,
  },
  data() {
    return {
      // status 订单状态 0:初始化(前端查询)， 1:初始化完成， 4:订单失效
      // payStatus 0:待支付， 1:已支付完成
      orderInfo: {},
      paymentDialogVisible: false, // 支付弹窗是否显示
      couponType: 0, // 优惠券选择类型
      paymentMethod: PAYMENT_METHOD.ALIPAY, // 支付方式
      orderId: '', // 订单id
      isTying: false, // 是否搭售
      couponList: [], // 优惠券列表
      currentCoupon: null, // 当前使用的优惠券
      invoiceNum: '', // 发票号
      isInSaas: false, // 是否在saas内
      // ============= 原有数据 s =============
      numberCal,
      max: this.$route.query.max ? parseInt(this.$route.query.max) : 99999,
      addressInfo: {
        receiverAddress: '',
        receiverName: '',
        receiverPhone: '',
      },
      sourceChannel: Number(sessionStorage.getItem('source_channel')) || 0,
      isDeliver: 0,
      choosedPackage: {},
      num: this.$route.query.num || 1,
      saleMark: '', // 售卖对象
      productType: '',
      saleType: '',
      exeTotalNum: '',
      extPrice: '',
      commodityNo: '',
      billingProductId: '',
      pdfLoading: true,
      showAddress: true,
      isContinuedValidityTerm: 2, // 订单生效时间类型 1：原订单结束后自动延续 2：指定时间生效
      hideContinuedType: false,
      haveOrders: false,
      lastEndTime: '',
      paying: false, // 是否正在支付
      useTime: '',
      menuData: {},
      count: 0,
      commodityName: '',
      commoditieData: [],
      dialogVisible: false,
      loading: false,
      protocol: '',
      invoice: 1,
      invoiceData: {},
      totalNum: '',
      packages: [],
      billForm: {
        menu: 0,
        express: 0,
        total: 0,
      },
      form: {
        invoiceAddress: '',
        invoiceForm: 1,
        invoiceEmail: '',
        invoiceTelephone: '',
        bank: '',
        invoiceType: '',
        identifyNumber: '',
        bankAccount: '',
      },
      invoiceTypeList: [
        {
          value: 1,
          label: $t('增值税普通发票'),
        },
        {
          value: 2,
          label: $t('增值税专用发票'),
        },
      ],
      invoiceType: {
        // 普通发票
        normalInvoiceForm: 'ELECTRON', // PAPER-纸质; ELECTRON-电子
        // 特殊发票
        specialInvoiceForm: 'ELECTRON', // PAPER-纸质; ELECTRON-电子
      },

      bank: '',
      // 访问pdf定时器
      getPdfTimer: null,
      saleOff: '',
      discountType: '',
      discountAmount: '',
      discounted: 0,
      promotionDisplay: false, // 优惠方式
      checkCoupons: false,
      couponsNumber: null,
      coupenName: '', // 优惠券名称
      activeNo: null,
      disableTimeChange: parseInt(this.$route.query.source_channel) === 9,
      getInTime: Date.now(),
      firstReqTime: null,
      lastResTime: null,
      tyingInfo: [], // 搭售信息
      companyCode: '', // 公司主体 esign-天谷；KingGridJX-江西金格；KingGridGZ-广州金格；KingGridBJ-北京金格；HealthSP-易签宝；
      // ============= 原有数据 e =============
      // 顺手购商品列表
      selectTyingSaleSchemaList: [],
    }
  },
  computed: {
    // 订单是否失效 status 订单状态 0:初始化(前端查询)， 1:初始化完成， 4:订单失效
    isInvalid() {
      return this.orderInfo.status === 4
    },
    // 订单是否支付完成 payStatus 0:待支付， 1:已支付完成
    isPaySuccess() {
      return this.orderInfo.payStatus === 1
    },
    // 待支付页面
    waitPay() {
      return Boolean(this.orderId) || this.$route.name === 'RechargeOnline'
    },
    // 商品标准价格（总价）
    menuStandardPrice() {
      // 订单页时显示详情接口返回的标准价格，否则显示下单页的
      if (this.waitPay) {
        return this.orderInfo.originalPrice || this.orderInfo.price
      }

      return this.numberCal.mul(this.billForm.menu || 0, this.num.toFixed(2))
    },
    // 商品总价显示价格
    menuStandardPriceDisplay() {
      return this.menuStandardPrice?.toFixed(2) || '0.00'
    },
    // 标准价格
    standardPrice() {
      return ((this.menuData.standardPrice || 0) * this.num).toFixed(2)
    },
    // 商品总价
    menuTotalPrice() {
      return this.returnSaleMoney(this.menuData.totalPrice || 0).toFixed(2)
    },
    // 付款金额> 已下单：主商品金额+顺手购商品金额-已支付金额，下单页：主商品金额（包含运费）+顺手购商品金额
    payAmount() {
      if (this.waitPay) {
        return this.orderInfo.price + this.tyingSceneAmount - (this.orderInfo.amountPaid || 0)
      }

      return this.payAmountNumber + this.tyingSceneAmount
    },
    // 付款显示金额
    payAmountDisplay() {
      return this.payAmount?.toFixed(2) || '0.00'
    },
    payAmountNumber() {
      return this.returnSaleMoney(this.billForm.menu || 0) + (this.billForm.express || 0)
    },
    // 顺收购商品金额
    tyingSceneAmount() {
      return (
        this.selectTyingSaleSchemaList?.reduce((total, item) => {
          return total + (item.discountPrice || 0)
        }, 0) || 0
      )
    },
    // 支付剩余时间
    waitSeconds() {
      return this.orderInfo?.webParameter?.payInvalidTime
        ? Math.round((this.orderInfo?.webParameter?.payInvalidTime - Date.now()) / 1000)
        : this.orderInfo?.webParameter?.payInvalidTime
    },
    // ============= 原有数据 s =============
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
      tsignData: state => state.tsignData,
    }),
    // 通过链接参数控制是否隐藏订单续延生效
    hideAutoContinue() {
      const { hideAutoContinue } = this.$route.query
      const hide = Number(hideAutoContinue) || 0

      return hide === 1
    },
    /** 隐藏原订单结束后自动延续
     * hideAutoContinue 上游传递 1 - 隐藏 0 - 展示
     */
    showAutoBuy() {
      return this.lastEndTime && this.haveOrders && !this.hideAutoContinue
    },
    // ============= 原有数据 e =============
  },
  created() {
    this.isInSaas = window.__POWERED_BY_QIANKUN__
    this.orderId = this.$route.query.orderId
    // 通过传参控制是否展示订单生效时间(默认选择指定时间生效)
    this.hideContinuedType = Number(this.$route.query.continuedType) === 1
    this.isContinuedValidityTerm = this.hideContinuedType ? 1 : 2
    if (this.$route.query.tsign_source_type === 'DITCH' && this.$route.query.ditchID) {
      this.getPromoInfo(this.$route.query.ditchID)
    } else {
      this.init()
    }
    // saas内监听企业空间变化
    if (this.isInSaas) {
      this.$EventBus?.$on('SpaceChanged', this.monitEnterprEiseSpace)
    }
  },
  beforeDestroy() {
    this.$EventBus?.$off('SpaceChanged', this.monitEnterprEiseSpace)
  },
  methods: {
    // saas企业控制台内嵌企业空间变化时退回到上个页面（企业账户）
    monitEnterprEiseSpace() {
      // 回退两页是因为企业空间变动会产生一个新的popstate
      window.history.go(-2)
    },
    // 关闭支付弹窗进入支付等待页面
    handlePayClose() {
      if (this.$route.name === 'MyOrderConfirm') {
        this.$router.replace({
          path: '/RechargeOnline',
          query: {
            orderId: this.orderId,
            fee: this.billForm.express,
            invoiceId: this.invoiceNum,
            invoiceOnline: this.invoice === 2 ? 1 : 0,
            isDeliver: this.isDeliver,
            sourceFrom: 'comfirm', // 跳转支付页来源，用于控制是否获取展示顺手购
          },
        })
      }
    },
    // 重新下单
    // handleReOrder() {
    //   this.$router.replace({
    //     path: '/MyOrder/comfirm',
    //     query: {
    //       commodityId: this.orderInfo.commodityId,
    //       menuId: this.orderInfo.saleInfoId,
    //       ...{
    //         source_channel: this.sourceChannel,
    //         channelGid: this.orderInfo.channelGid,
    //       },
    //     },
    //   })
    // },
    async initOrderInfo() {
      if (this.orderId) {
        this.$nextTick(async () => {
          const orderInfo = await this.$refs.paymentRef.pageInit()
          this.orderInfo = orderInfo
          // this.initPageData(orderInfo)
          this.saleType = orderInfo.saleType // 售卖类型
          this.isContinuedValidityTerm = orderInfo.isAutoRenewal ? 1 : this.isContinuedValidityTerm // 选择的订单生效时间类型
          // 订单生效时间
          this.useTime = orderInfo.validationDate
          if (orderInfo.num) this.num = orderInfo.num
          if (orderInfo.activeInfo) {
            this.setCouponInfo(orderInfo.activeInfo)
            this.couponType = orderInfo.activeInfo.activeNo ? 1 : 0
            this.discounted = orderInfo.originalPrice - orderInfo.price
          }
          this.totalNum = this.orderInfo.totalNum
          this.isDeliver = orderInfo.isDeliver

          // 有效期
          this.orderInfo.effective = this.calculateEffectiveTime(this.orderInfo)
          this.tyingInfo = orderInfo.tyingActiveInfo || []
          this.isTying = orderInfo.isTying
          this.getHistoryOrderInfo({
            saleSchemaId: orderInfo.saleSchemaId,
            productId: orderInfo.productId,
          })
          this.count = Number(this.$route.query.amount) || orderInfo.originalPrice || orderInfo.price || 0
          // 等count变化执行完watch
          this.$nextTick(() => {
            if (orderInfo.invoiceInfo?.length > 0) {
              this.invoice = 2
              this.form = orderInfo.invoiceInfo?.[0] || null
            }
          })
          this.loading = false
          this.handleOrderStatus()
        })
      }
    },
    // 计算有效期
    calculateEffectiveTime(data) {
      let unit = ''
      if (this.saleType === 2) {
        unit = $t('无限')
      }
      if (this.saleType === 1 || this.saleType === 3) {
        if (data.isUnLimitTime) {
          unit = $t('无限')
        } else {
          if (data.effectiveUnit === 'DAY') {
            unit = $t('{slot1}天', { slot1: data.effectiveDate })
          } else if (data.effectiveUnit === 'YEAR') {
            unit = $t('{slot1}年', { slot1: data.effectiveDate })
          } else if (data.effectiveUnit === 'MONTH') {
            unit = $t('{slot1}月', { slot1: data.effectiveDate })
          }
        }
      }

      return unit || '--'
    },
    // 订单状态流转
    handleOrderStatus() {
      const { payStatus } = this.orderInfo
      // status 订单状态 0:初始化(前端查询)， 1:初始化完成， 4:订单失效(目前失败原因只有订单超时失效)
      // payStatus 支付状态 0:待支付， 1:已支付完成
      // 订单失效或支付成功跳转结果页
      // if (status === 4 || payStatus === 1) {
      // 支付完成跳转结果页
      if (payStatus === 1) {
        this.$router.replace({
          path: '/result',
          query: {
            ...this.$router.currentRoute.query,
            payOrderId: this.payOrderId,
            invoiceId: this.currentInvoiceId,
          },
        })
      }
      // 默认可下单
    },
    // 去支付
    submitPayment: debounce(
      async function () {
        if (this.paymentMethod === PAYMENT_METHOD.BANK && this.selectTyingSaleSchemaList.length > 0) {
          return this.$message.error(this.$t('顺手购活动暂不支持对公转账，请选择其他方式支付'))
        }
        if (this.orderId) {
          this.paying = true
          await this.$refs.paymentRef?.handleConfirmPayment()
          this.paymentDialogVisible = true
          this.paying = false

          return
        }
        this.createOrder()
      },
      debounceTime,
      true
    ),
    reportGetCustomerSupport() {
      this.reportSourceChannel('order_pendingPayment_consult')
    },
    // ============= 原有数据 s =============

    // http://wiki.timevale.cn:8081/pages/viewpage.action?pageId=206901736
    reportSourceChannel(name) {
      const personOid = localStorage.getItem('ouid')
      const personGid = localStorage.getItem('guid')
      const data = {
        commodity_number: (this.totalNum || this.exeTotalNum) * this.num,
        commodity_name: this.commodityName || 'pcerror',
        commodity_id: this.$route.query.commodityId,
        user_type: this.isOrg ? '企业' : '个人',
        oid: this.isOrg ? this.userInfo.orgId : personOid,
        gid: this.isOrg ? this.userInfo.gid : personGid,
        pay_amount: (this.returnSaleMoney(this.billForm.menu) + this.billForm.express).toFixed(2),
        geren_oid: personOid,
        geren_gid: personGid,
        order_source: orderSourceMap[this.sourceChannel] || 'other',
        order_id: '-',
      }
      tsignDataTrack.track(name, data)
    },
    // 上报神策埋点
    reportShenCeData(lastResTime) {
      let dataObj = getTimingData($t('我的订单-下单'))
      let reqDataObj = {}
      if (this.lastResTime) {
        // 代表一定触发了接口请求且有返回
        reqDataObj = {
          businessData_load_time: lastResTime - this.firstReqTime,
          time_consume: lastResTime - window.performance.timing.fetchStart,
        }
        dataObj = { ...dataObj, ...reqDataObj }
      }
      tsignDataTrack.track('front_init_time_consume', dataObj)
    },
    async getCoupons(couponsNumber, couponType) {
      this.couponsNumber = couponsNumber // 输入的优惠券码
      if (this.saleType === 2) {
        // 充值类型的订单
        await this.getExecRule(this.count, this.count)
      } else {
        await this.getExecRule(this.choosedPackage.totalNum, this.choosedPackage.price, couponsNumber)
      }
    },
    // 使用优惠券
    changeCoupon(couponType, data) {
      this.currentCoupon = data // 设置当前使用的优惠券
      this.couponType = couponType // 使用优惠券
      if (couponType === 1) {
        // this.couponsNumber = couponsNumber
        this.couponsNumber = data.activeNo
        // 优惠券
        this.activeNo = data.activeNo
        if (data.discountType === 0) {
          this.saleOff = $t('优惠{slot1}元', { slot1: data.discountAmount })
        } else if (data.discountType === 1) {
          this.saleOff = $t('打{slot1}折', { slot1: numberCal.mul(data.discountAmount, 10) })
        }
        this.discountType = data.discountType
        this.discountAmount = data.discountAmount
        this.discounted = data.discounted
        this.coupenName = data.name
      } else {
        this.clearCouponInfo()
      }
    },
    // 获取优惠
    getPromoInfo(channelGid) {
      this.firstReqTime = Date.now()
      this.$ajax(this.$url.getPromo(), { channelGid }).then(res => {
        this.promotionDisplay = res.data
        this.lastResTime = Date.now()
        this.init()
      })
    },
    getVal(val) {
      this.addressInfo.receiverAddress = val.receiverAddress
      this.addressInfo.receiverName = val.receiverName
      this.addressInfo.receiverPhone = val.receiverPhone
    },
    handleClose() {
      this.getPdfTimer && clearInterval(this.getPdfTimer)
    },
    handleChange(v) {
      this.$nextTick(() => {
        this.num = parseInt(v) || 1
        this.invoice = 1 // TODO: 这个逻辑会导致修改数量开票信息隐藏，沿用老逻辑
        this.billForm.express = 0
        this.couponList = []
        this.clearCouponInfo()
        this.getExecRule(this.choosedPackage.totalNum, this.choosedPackage.price)
      })
    },
    // 获取历史订单信息
    async getHistoryOrderInfo(params) {
      const getHistoryRes = await this.$ajax(this.$url.getHistoryUsed(), params)
      this.haveOrders = getHistoryRes?.data?.haveOrders
      this.lastEndTime = getHistoryRes?.data?.lastEndTime

      return getHistoryRes
    },
    // 页面信息初始化
    async initPageData(data) {
      this.lastResTime = Date.now()
      this.companyCode = data.companyCode
      this.commodityNo = data.commodityNo
      this.isDeliver = data.isDeliver
      this.saleMark = data.saleMark
      this.commodityName = data.commodityName
      this.productType = data.billingProduct?.productType
      this.saleType = data.saleType
      this.billingProductId = data.billingProductId
      if (this.saleType === 1 || this.saleType === 3) {
        this.menuData = { saleOff: $t('无优惠'), menu: '', ...data }
        this.packages = this.saleType === 1 ? this.menuData.packages : this.menuData.licenses

        let id = ''
        if (this.$route.query.menuId) {
          id = Number(this.$route.query.menuId)
        } else if (this.saleType === 1) {
          id = this.menuData?.packages?.[0]?.id
        } else if (this.saleType === 3) {
          id = this.menuData?.licenses?.[0]?.id
        }
        this.chooseMenu(id, Number(this.$route.query.amount))
        this.menuData.menu = id
      } else if (this.saleType === 2) {
        this.count = Number(this.$route.query.amount) || 1
        this.menuData = {
          saleOff: $t('无优惠'),
          effective: $t('无限'),
          totalPrice: 1,
          menu: '',
          ...data,
        }

        this.getBillMoney()
        this.getExecRule(this.count, this.count)
      }
      this.loading = false
      this.isConsiderUsageAmount = data.billingProduct?.isConsiderUsageAmount
      const params = {
        saleSchemaId: data.saleSchemeId,
        productId: data.billingProduct?.id,
      }
      await this.getHistoryOrderInfo(params)
      // 如果存在历史生效订单，则订单生效时间类型为原订单结束后自动延续
      this.isContinuedValidityTerm = this.showAutoBuy ? 1 : this.isContinuedValidityTerm
      if (this.isOrg) {
        this.$ajax(this.$url.orgGetInfo()).then(res => {
          this.form.identifyNumber =
            res.data?.prop?.credentials?.usccCode ||
            res.data?.prop?.credentials?.taxCode ||
            res.data?.prop?.credentials?.regCode ||
            res.data?.prop?.credentials?.orgCode
        })
      }
      this.reportSourceChannel('to_creat_order')
    },
    async init() {
      this.firstReqTime = Date.now()
      this.form.invoiceType = 1
      this.useTime = +new Date()
      this.loading = true

      if (this.$route.query.commodityId) {
        const res = await this.$ajax(this.$url.getCommodities(), {
          id: this.$route.query.commodityId,
          showcaseNos: this.$route.query.showcaseNos ? [this.$route.query.showcaseNos] : [],
        })

        // 当前没优惠活动，自动匹配优惠
        // if (!this.$route.query.condCode) {
        //   this.$ajax(this.$url.getPackages(), {
        //     productId: res.data.billingProductId,
        //   }).then(res => {
        //     // 取出所有商品详情的折扣列表
        //     const allActiveDiscounts = (res.data.commodityDetailList || []).flatMap(item => item.activeDiscountList || [])
        //     // 找到 discountPrice 最低的折扣项
        //     let minDiscount = null
        //     if (allActiveDiscounts.length > 0) {
        //       minDiscount = allActiveDiscounts.reduce((prev, curr) => (
        //         prev.discountPrice < curr.discountPrice ? prev : curr
        //       ))
        //     }
        //     // 取出最低价的 condCode，如果没有则为 null
        //     const minCondCode = minDiscount ? minDiscount.condCode : null
        //     if (minCondCode) {
        //       this.$router.replace({
        //         path: this.$route.path,
        //         query: {
        //           ...this.$route.query,
        //           condCode: minCondCode
        //         }
        //       })


        //     }

        //   })
        // }

        if (this.$route.query.menuId) {
          this.$ajax(this.$url.getTying(), {
            saleInfoId: this.$route.query.menuId,
          }).then(res => {
            this.tyingInfo = res.data?.tyingInfoList || []
            this.isTying = res.data.isTying
          })
        }
        this.initPageData(res.data)
      } else {
        if (!this.orderId) this.$message.error($t('缺少参数'))
      }
      this.initOrderInfo()
      this.reportShenCeData(this.lastResTime)
    },
    viewCert() {
      window.open('https://asset.esign.cn/template/agreement.html', '_blank')
    },
    getExel() {
      this.getExecRule(this.count, this.count)
    },
    chooseMenu(val, num) {
      this.num = num || 1
      const choosedPackage = this.packages?.filter(item => item.id === val)[0]
      this.totalNum = choosedPackage.totalNum
      let unit = ''
      if (choosedPackage.effectiveIsUnlimited === 0) {
        if (choosedPackage.effectiveUnit === 'DAY') {
          unit = $t('{slot1}天', { slot1: choosedPackage.effectiveDate })
        } else if (choosedPackage.effectiveUnit === 'YEAR') {
          unit = $t('{slot1}年', { slot1: choosedPackage.effectiveDate })
        } else if (choosedPackage.effectiveUnit === 'MONTH') {
          unit = $t('{slot1}月', { slot1: choosedPackage.effectiveDate })
        }
      } else if (choosedPackage.effectiveIsUnlimited === 1) {
        unit = $t('无限')
      }
      this.menuData.standardPrice = choosedPackage.price
      this.menuData.effective = unit || '--'
      this.menuData.totalPrice = choosedPackage.price
      this.menuData.packageName = choosedPackage.packageName || choosedPackage.licenseName
      this.invoice = 1
      this.getBillMoney()
      if (this.returnSaleMoney(this.billForm.menu) >= 1000 || this.form.invoiceForm === 1 || this.invoice === 1) {
        this.billForm.express = 0
      } else if (this.returnSaleMoney(this.billForm.menu) < 200) {
        this.billForm.express = 0
      } else {
        this.billForm.express = this.invoiceData.fee || 0
      }
      this.getBillMoney()
      this.getExecRule(choosedPackage.totalNum, choosedPackage.price)
    },
    getInvoiceInfo(data) {
      this.invoiceData = data
      if (this.returnSaleMoney(this.billForm.menu) >= 1000 || this.form.invoiceForm === 1) {
        this.billForm.express = 0
      } else {
        this.billForm.express = data.fee
      }
      this.getBillMoney()
    },
    // returnShowSaleOff(name) {
    //   if (this.saleOff) {
    //     return this.saleOff
    //   }

    //   return name
    // },
    returnSaleMoney(money) {
      let saleMoney = money
      saleMoney *= this.num
      // 有优惠且选择使用优惠券
      if (this.saleOff && this.couponType === 1) {
        if (this.discountType === 1) {
          return saleMoney * this.discountAmount
        }

        return saleMoney - this.discountAmount
      }

      return saleMoney
    },
    // 清空优惠券赋值信息
    clearCouponInfo() {
      this.activeNo = null
      this.saleOff = ''
      this.discountType = ''
      this.discountAmount = ''
      this.couponsNumber = null
      this.discounted = 0
      this.coupenName = ''
    },
    // 设置优惠券信息
    setCouponInfo(data) {
      if (data == null || data.discountPrice < 0) {
        // 无优惠信息 重置订单数据
        if (data.discountPrice < 0) {
          this.$message.error($t('无法使用大于等于订单金额的优惠券'))
        }
        this.clearCouponInfo()

        return
      }
      // 如果优惠券列表为空 或者当前查询的优惠券与选中的相同则替换当前选中优惠券数据
      if (!this.couponList?.length || this.activeNo === data.activeNo) {
        this.couponType = 1 // 使用优惠券
        this.couponsNumber = data.activeNo
        // 优惠券
        this.activeNo = data.activeNo
        if (data.discountType === 0) {
          this.saleOff = $t('优惠{slot1}元', { slot1: data.discountAmount })
        } else if (data.discountType === 1) {
          this.saleOff = $t('打{slot1}折', { slot1: numberCal.mul(data.discountAmount, 10) })
        }
        this.discountType = data.discountType
        this.discountAmount = data.discountAmount
        this.discounted = data.discounted
        this.coupenName = data.name
        this.currentCoupon = data
      }
      // 如果优惠券列表中存在该优惠券则替换当前选中优惠券数据
      const couponIndex = this.couponList?.findIndex(item => item.activeNo === data.activeNo)
      // 优惠券列表中没有该优惠券 则添加到列表中
      if (couponIndex < 0) {
        this.couponList.push(data)
      } else {
        this.couponList[couponIndex] = data
      }
      this.checkCoupons = false
    },
    async getExecRule(totalNum, price, couponsNumber) {
      if (totalNum && price) {
        this.exeTotalNum = totalNum
        this.extPrice = price
      }
      const data = {
        commodityNo: this.commodityNo,
        price: (price || this.extPrice) * this.num,
        totalNum: (totalNum || this.exeTotalNum) * this.num,
        productId: this.billingProductId,
        showcaseNo: '',
        agentId: this.$route.query.agentId,
        gid: this.userInfo.gid,
        // 如果传入优惠券码则使用传入的优惠券码，否则使用当前选中的优惠券码（下单直减的不需要传优惠券码）
        promoCode: couponsNumber || this.currentCoupon?.promotionDisplay !== 1 ? this.couponsNumber : '',
        channelGid: this.$route.query.ditchID,
        condCode: this.$route.query.condCode,
      }

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.execRule(), data)
          .then(res => {
            resolve(res)
            this.setCouponInfo(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取开票配置类型
    getInvoiceType(companyCode) {
      if (companyCode) {
        this.$ajax(this.$url.getInvoiceType(), { companyCode }).then(res => {
          this.invoiceType.normalInvoiceForm = res.data.normalInvoiceForm
          this.invoiceType.specialInvoiceForm = res.data.specialInvoiceForm
          this.form.invoiceForm = res.data.normalInvoiceForm === 'PAPER' ? 2 : 1
        })
      }
    },
    invoiceSubmit(form) {
      this.form = {
        ...this.form,
        ...form,
      }
    },
    needInvoice(v) {
      this.invoice = v
      this.getInvoiceType(this.companyCode)
      if (this.returnSaleMoney(this.billForm.menu) >= 1000 || this.form.invoiceForm === 1 || this.invoice === 1) {
        this.billForm.express = 0
      } else {
        this.billForm.express = this.invoiceData.fee || 0
      }
      this.getBillMoney()
    },
    handleInput(e) {
      this.count = e.replace(/[^\d]/g, '')
      if (this.count < 500) {
        this.form.invoiceType = 1
      }
      this.couponList = []
      this.clearCouponInfo()
      this.getExecRule(this.count, this.count)
    },
    getBillMoney() {
      this.billForm.menu = this.menuData.totalPrice
      if (this.invoice === 1 || this.billForm.menu >= 1000) {
        this.billForm.total = this.billForm.menu
      } else {
        this.billForm.total = this.billForm.menu + this.billForm.express
      }
    },
    // eslint-disable-next-line complexity
    getParams() {
      let invoice = {}
      if (this.invoice === 1) {
        invoice = {
          /* i18n-ignore */
          type: '线上', //  线下
          invoiceTitleName: null, //  发票抬头
          invoiceType: null, //  发票类型:  1-增值税普通发票;  2-增值税专用发票
          invoiceForm: null, //  开票形式:  1-电子;  2-纸质
          fee: null, //  邮费
          identifyNumber: null, //  纳税人识别号
          bank: null, //  开户银行
          bankAccount: null, //  银行账号
          invoiceAddress: null, //  开票地址
          invoiceTelephone: null, //  开票电话
          email: null, //  接收邮箱
          invoiceRemark: null, //  开票备注
          receiver: null, //  收件人
          receiveAddress: null, //  收件地址
          receivePhone: null, //  收件电话
          expressPayMethod: null, //  快递支付方式:  1-寄付;  2-到付
        }
      } else {
        invoice = {
          /* i18n-ignore */
          type: '线上', //  线下
          invoiceTitleName: this.userInfo.name || null, //  发票抬头
          invoiceType: +this.form.invoiceType, //  发票类型:  1-增值税普通发票;  2-增值税专用发票
          invoiceForm: this.form.invoiceForm, //  开票形式:  1-电子;  2-纸质
          fee: this.billForm.express, //  邮费
          identifyNumber: this.form.identifyNumber || null, //  纳税人识别号
          bank: this.form.bank || null, //  开户银行
          bankAccount: this.form.bankAccount || null, //  银行账号
          invoiceAddress: this.form.invoiceAddress || null, //  开票地址
          invoiceTelephone: this.form.invoiceTelephone || null, //  开票电话
          email: this.form.invoiceEmail || null, //  接收邮箱
          invoiceRemark: null, //  开票备注
          receiver: this.form.invoiceForm === 1 ? '' : this.invoiceData.address ? this.invoiceData.address.contact : '', //  收件人
          receiveAddress: this.form.invoiceForm === 1 ? '' : this.invoiceData.address ? this.invoiceData.address.addressAll : '', //  收件地址
          receivePhone: this.form.invoiceForm === 1 ? '' : this.invoiceData.address ? this.invoiceData.address.contactNumber : '', //  收件电话
          expressPayMethod: +this.invoiceData.expressType, //  快递支付方式:  1-寄付;  2-到付
        }
      }
      invoice.customerName = this.userInfo.name
      invoice.customerType = this.isOrg ? 1 : 0
      // 组装参数
      let commodities = {}
      if (this.menuData.saleType === 1 || this.menuData.saleType === 3) {
        commodities = {
          commodityId: this.menuData.id, //  商品ID
          activeNo: this.couponType === 1 ? this.activeNo : '', // 优惠券使用时，activeNo为1
          num: this.num,
          specification: {
            //  规格
            id: this.menuData.menu, //  充值或套餐的ID
            idType: this.saleType === 1 ? 'plan' : 'license', //  rule或plan
            realVolumn: this.packages.filter(x => x.id === this.menuData.menu)[0].totalNum, //  套餐数量
            isContinuedValidityTerm: this.isContinuedValidityTerm === 1,
          },
        }
      } else {
        commodities = {
          commodityId: this.menuData.id, //  商品ID
          activeNo: this.couponType === 1 ? this.activeNo : '', // 优惠券使用时，activeNo为1
          specification: {
            //  规格
            id: this.menuData.billingRules[0].id, //  充值或套餐的ID
            idType: 'rule', //  rule或plan
            realAmount: this.billForm.menu, //  套餐数量
            isContinuedValidityTerm: this.isContinuedValidityTerm === 1,
          },
        }
      }
      // 组装顺手购商品，isContinuedValidityTerm和主订单保持一致
      const selectTyingSaleSchemaList = this.selectTyingSaleSchemaList.map(item => {
        return {
          commodityId: item.commodityId,
          activeTyingConfigId: item.tyingActiveConfigId,
          activeNo: item.activeNo,
          num: 1,
          specification: {
            id: item.saleSchemaId,
            idType: item.saleType === 1 ? 'plan' : 'license',
            realVolumn: item.totalNum,
            isContinuedValidityTerm: this.isContinuedValidityTerm === 1,
          },
        }
      })
      const params = {
        commodities: [commodities, ...selectTyingSaleSchemaList],
        businessId: this.$route.query.businessId,
        _latest_tsign_source_type: this.$route.query.tsign_source_type || this.tsignData._latest_tsign_source_type,
        _latest_tsign_source_detail: this.$route.query.tsign_source_detail || this.tsignData._latest_tsign_source_detail,
        platformType: 'WEB',
        accountingInfo: {
          totalAmount: this.billForm.menu, //  下单总额
        },
        validDateTime: this.useTime, //  订单生效时间
        invoice: {
          //  发票项
          ...invoice,
        },
        addressInfo: this.addressInfo,
        needInvoice: this.invoice !== 1, //  是否需要发票
        sourceChannel: this.sourceChannel,
        settleContext: {
          cooperatorId: this.$route.query.cooperatorId || '',
          cooperatorMode: this.$route.query.cooperatorMode || '',
          projectCode: this.$route.query.projectCode || '',
        },
        extendedParams: {
          promotionSource: this.$route.query.promotionSource || '', // 推广来源
          appId: this.$route.query.appId || '',
        },
      }
      return params
    },

    async payment() {
      try {
        // 获取订单号（乐胥）
        const data = this.getParams()
        data.clientChannel = 0
        data.licenseId = this.$route.query.licenseId
        data.agentId = this.$route.query.agentId
        data.channelGid = this.$route.query.ditchID
        data.condCode = this.$route.query.condCode
        const res = await this.$ajax(this.$url.getBillIds(), data)
        const { orderIds = [], invoiceNum = '', mainOrderId, orderDetails } = res.data || {}
        this.invoiceNum = invoiceNum
        if (orderIds === null) {
          this.$message.error($t('生成订单失败'))
          this.paying = false

          return
        }
        this.$reportBusiness('business_monitor_event_start', 'order_pay', {
          appId: this.$route.query.appid,
          ouid: this.userInfo.gid,
          orgId: this.userInfo.orgId,
          orderId: mainOrderId,
          stage: 'OrderConfirm',
        })
        // 顺手购商品订单列表(过滤掉主商品订单)
        const tyingSaleOrders = orderDetails?.filter(item => item.orderId !== mainOrderId) || []
        this.$nextTick(async () => {
          const orderInfo = await this.$refs.paymentRef.pageInit({
            ...this.$route.query,
            orderId: mainOrderId,
            fee: this.billForm.express,
            isDeliver: this.isDeliver,
            invoiceId: invoiceNum,
            invoiceOnline: this.invoice === 2 ? 1 : 0,
            tyingSaleOrders,
          })
          this.orderId = mainOrderId
          this.orderInfo = orderInfo
          await this.$refs.paymentRef?.handleConfirmPayment()
          this.paymentDialogVisible = true
          this.paying = false
          // TODO: 顺手购商品
          this.reportSourceChannel('to_select_commodity')
        })
      } catch (error) {
        this.paying = false
      }
    },
    async createOrder() {
      if (this.invoice === 2 && this.returnSaleMoney(this.billForm.menu) >= 2000000 && this.form.invoiceType === 1) {
        return this.$message.error($t('抱歉，单次发票可开具金额为1999999.99，请联系客服获取发票。'))
      }
      if (!this.addressInfo.receiverAddress && this.isDeliver) {
        return this.$message.error($t('请选择收货地址'))
      }
      this.userInfo.orgId && (await this.$ajax(this.$url.space(this.userInfo.orgId)))
      this.pay()
    },
    // eslint-disable-next-line complexity
    async pay() {
      if (!this.useTime && this.isContinuedValidityTerm === 2) {
        this.$message.error($t('请选择订单生效时间'))

        return
      }

      if (!(this.invoiceData.address && this.invoiceData.address.contact) && this.invoice === 2 && this.form.invoiceForm === 2) {
        this.$message.error($t('请选择收货地址'))

        return
      }
      const data = {
        commodityNo: this.commodityNo,
        price: this.extPrice * this.num,
        totalNum: this.exeTotalNum * this.num,
        productId: this.billingProductId,
        agentId: this.$route.query.agentId,
        gid: this.userInfo.gid,
        // 使用下单直接优惠的优惠券时不传优惠券码（否则会报错）
        promoCode: this.couponType === 1 && this.currentCoupon.promotionDisplay !== 1 ? this.currentCoupon.activeNo : '', //
        // promoCode: this.couponType === 1 ? this.couponsNumber : '', //
        channelGid: this.$route.query.ditchID,
        condCode: this.$route.query.condCode,
      }
      this.paying = true
      try {
        const res = await this.$ajax(this.$url.execRule(), data)
        // 判断优惠券状态是否有变化
        const isCouponTypeZero = this.couponType === 0 // 不使用优惠券
        const isNoActivePromotion = res.data == null && this.activeNo == null
        const isActiveNoUnchanged = (res.data && res.data.activeNo) === this.activeNo
        // 检查优惠状态是否发生变化
        const isPriceChanged = !isCouponTypeZero && !isNoActivePromotion && !isActiveNoUnchanged
        // 如果优惠状态发生变化，提示用户刷新页面
        if (isPriceChanged) {
          this.$alert($t('产品价格发生变更，请点击确定，页面将自动刷新！'), $t('提示'), {
            confirmButtonText: $t('确定'),
            callback: () => {
              this.$router.go(0)
            },
          })
          this.paying = false

          return
        }
      } catch (error) {
        this.paying = false
      }
      const regexp = /^((?:(?:(\+)|(00))86)?1\d{10})$|^([48]00-?\d{3}-?\d{4})$|^((?:0\d{2,3}-)?(\d{5,8}(-\d{3,5})?))$/
      const regexp1 = /^([a-zA-Z0-9]{15}|[a-zA-Z0-9]{18}|[a-zA-Z0-9]{20}|)$/
      const regEx = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      // 普通发票提交时的前端校验，开户银行+银行账户
      if ((this.form.bank === '' && this.form.bankAccount) || (this.form.bank && this.form.bankAccount === '')) {
        this.$message.error($t('开票银行名称和开票银行账户需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息'))
        this.paying = false

        return false
      }
      // 开票地址+开票电话
      if (
        (this.form.invoiceAddress === '' && this.form.invoiceTelephone) ||
        (this.form.invoiceAddress && this.form.invoiceTelephone === '')
      ) {
        this.$message.error($t('开票地址和开票电话需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息'))
        this.paying = false

        return false
      } else if (this.form.invoiceTelephone && !regexp.test(this.form.invoiceTelephone)) {
        this.$message.error($t('请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888'))
        this.paying = false

        return false
      } else if (this.form.identifyNumber && !regexp1.test(this.form.identifyNumber)) {
        this.$message.error($t('纳税人识别号请输入15或18位数字或字母的组合'))
        this.paying = false

        return false
      }
      // 接收邮箱
      if (this.form.invoiceType === 2 && this.form.invoiceForm === 1) {
        if (this.form.invoiceEmail && !regEx.test(this.form.invoiceEmail)) {
          this.$message.error($t('请正确填写接收邮箱'))
          this.paying = false

          return false
        }
      }
      this.payment()
    },
    // ============= 原有数据 e =============
    // 搭售商品选择项更新
    tyingSaleSelectChange(list) {
      this.selectTyingSaleSchemaList = list || []
    },
  },
  // ============= 原有数据 s =============
  watch: {
    invoice: {
      handler(v) {
        console.log('invoice1>>', v)
      },
      immediate: true,
    },
    form: {
      handler(value) {
        if (value.invoiceForm === 2) {
          this.showAddress = true
          if (this.returnSaleMoney(this.billForm.menu) >= 1000) {
            this.billForm.express = 0
            this.billForm.total = this.billForm.menu
          } else {
            this.billForm.express = this.invoiceData.fee || 0
            this.billForm.total = this.billForm.menu + this.billForm.express
          }
        } else {
          this.billForm.express = 0
          this.billForm.total = this.billForm.menu
          this.showAddress = false
        }
      },
      deep: true,
    },
    count: {
      handler(newVal) {
        this.invoice = 1
        this.billForm.express = 0
        if (newVal) {
          this.menuData.standardPrice = parseFloat(newVal)
          this.menuData.totalPrice = parseFloat(newVal)
          this.getBillMoney()
        } else {
          this.menuData.standardPrice = 0
          this.menuData.totalPrice = 0
          this.getBillMoney()
        }
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    // eslint-disable-next-line no-prototype-builtins
    if (to.query.hasOwnProperty('operating')) {
      const query = JSON.parse(base64Decode(to.query.operating))
      Object.keys(query).forEach(item => {
        to.query[item] = query[item]
      })
    }
    next()
  },
  // ============= 原有数据 e =============
}
</script>

<style lang="less" scoped>
.main {
  .order-confirm {
    min-width: unset;
    overflow-y: auto;
  }
}

.common-header {
  .breadcrumb {
    display: flex;
    align-items: center;
  }

  .goback {
    margin-right: 12px;
  }
}

.order-confirm {
  padding: 24px;
  background: #f2f3f5;
  display: flex;
  flex-direction: column;
  height: calc(100% - 52px);

  .container {
    min-height: 100%;
    width: 1078px;
    margin: 0 auto;
  }

  .pay-countdown {
    margin-bottom: 24px;
  }

  .content {
    // margin: 0 auto;
    display: flex;
    min-height: 100%;
  }

  .product {
    width: 660px;
  }

  .pay {
    width: 394px;
    margin-left: 24px;
    align-self: flex-start;
  }
}

@media screen and (max-width: 1340px) {
  .order-confirm {
    overflow-y: auto;

    .container {
      width: 660px;
    }

    .content {
      flex-direction: column;
      width: 660px;
      height: auto;
    }

    .product {
      width: 100%;
    }

    .pay {
      width: 100%;
      margin-left: 0;
      margin-top: 24px;
    }
  }
}
</style>
